<template>
  <div class="yunnan-content">
    <div class="central-yunnan-main">
      <!--  卡片总数量1  -->
      <div class="central-content">
        <div class="central-yunnan-main-item">
          <div class="central-yunnan-card1">
            <span class="card-title">总数量</span>
            <span class="card-num">{{ parseFloat(totalQuantity) }}</span>
            <span class="card-unit">个</span>
          </div>
        </div>
        <div class="central-yunnan-main-item">
          <div class="central-yunnan-card2">
            <span class="card-title">总面积</span>
            <span class="card-num">{{
              parseFloat(Number(grossArea.toFixed(3)))
            }}</span>
            <span class="card-unit">亩</span>
          </div>
        </div>
      </div>
      <!--  卡片总数量2  -->
      <div class="card2-content">
        <div class="card2-content-item">
          <div class="card2-content-name">住宅用地</div>
          <div class="card2-content-main-content">
            <div class="card2-content-main">
              <div class="card2-content-main-title">数量</div>
              <div class="card2-content-main-num">
                <span class="card2-content-num">{{
                  residential.totalQuantity
                }}</span>
                <span class="card2-content-unit">个</span>
              </div>
            </div>
            <div class="card2-content-main">
              <div class="card2-content-main-title">面积</div>
              <div class="card2-content-main-num">
                <span class="card2-content-num">{{
                  parseFloat(Number(residential.grossArea.toFixed(3)))
                }}</span>
                <span class="card2-content-unit">亩</span>
              </div>
            </div>
          </div>
        </div>
        <div class="card2-content-item">
          <div class="card2-content-name card2-content-name1">工矿仓储用地</div>
          <div class="card2-content-main-content card2-content-main-content1">
            <div class="card2-content-main">
              <div class="card2-content-main-title">数量</div>
              <div class="card2-content-main-num">
                <span class="card2-content-num">{{
                  keepGrain.totalQuantity
                }}</span>
                <span class="card2-content-unit">个</span>
              </div>
            </div>
            <div class="card2-content-main">
              <div class="card2-content-main-title">面积</div>
              <div class="card2-content-main-num">
                <span class="card2-content-num">{{
                  parseFloat(Number(keepGrain.grossArea.toFixed(3)))
                }}</span>
                <span class="card2-content-unit">亩</span>
              </div>
            </div>
          </div>
        </div>
        <div class="card2-content-item">
          <div class="card2-content-name card2-content-name2">商服用地</div>
          <div class="card2-content-main-content card2-content-main-content2">
            <div class="card2-content-main">
              <div class="card2-content-main-title">数量</div>
              <div class="card2-content-main-num">
                <span class="card2-content-num">{{
                  commercial.totalQuantity
                }}</span>
                <span class="card2-content-unit">个</span>
              </div>
            </div>
            <div class="card2-content-main">
              <div class="card2-content-main-title">面积</div>
              <div class="card2-content-main-num">
                <span class="card2-content-num">{{
                  parseFloat(Number(commercial.grossArea.toFixed(3)))
                }}</span>
                <span class="card2-content-unit">亩</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "yunnan",
  props: ["listArea"],
  // 片区地块数据啦!
  watch: {
    listArea: {
      handler(newVal) {
        if (!!newVal) {
          // 合并地块分类
          this.parcelMerge(newVal);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      // 合并的数据
      arrParcel: [],
      // 总数量
      totalQuantity: 0,
      // 总面积
      grossArea: 0,
      // 住宅用地
      residential: {
        // 总数量
        totalQuantity: 0,
        // 总面积
        grossArea: 0,
      },
      // 工矿仓储用地
      keepGrain: {
        // 总数量
        totalQuantity: 0,
        // 总面积
        grossArea: 0,
      },
      // 商服用地
      commercial: {
        // 总数量
        totalQuantity: 0,
        // 总面积
        grossArea: 0,
      },
    };
  },
  methods: {
    // 合并地块分类
    parcelMerge(newVal) {
      this.reset();
      newVal.forEach((item) => {
        if (!!item.dynamicTags && item.dynamicTags.length > 0) {
          item.dynamicTags.forEach((dynamicItem) => {
            if (!!dynamicItem.checkList && dynamicItem.checkList.length > 0) {
              dynamicItem.checkList.forEach((chechItem) => {
                this.arrParcel.push(chechItem);
              });
            }
          });
        }
        if (!!item.checkList && item.checkList.length > 0) {
          item.checkList.forEach((checkItem) => {
            this.arrParcel.push(checkItem);
          });
        }
      });
      // 统计
      this.amount();
    },
    // 筛选数据
    amount() {
      if (this.arrParcel.length > 0) {
        // 总数量
        this.totalQuantity = this.arrParcel.length;
        this.arrParcel.forEach((item) => {
          // 总面积
          this.grossArea += item.area;
          // 住宅用地
          if (item.type === "7") {
            this.residential.totalQuantity += 1;
            this.residential.grossArea += item.area;
          }
          // 工矿仓储用地
          if (item.type === "6") {
            this.keepGrain.totalQuantity += 1;
            this.keepGrain.grossArea += item.area;
          }
          // 商服用地
          if (item.type === "5") {
            this.commercial.totalQuantity += 1;
            this.commercial.grossArea += item.area;
          }
        });
      }
    },
    // 重置为空啊
    reset() {
      this.arrParcel = [];
      this.totalQuantity = 0;
      this.grossArea = 0;
      this.residential = {
        // 总数量
        totalQuantity: 0,
        // 总面积
        grossArea: 0,
      };
      this.keepGrain = {
        // 总数量
        totalQuantity: 0,
        // 总面积
        grossArea: 0,
      };
      this.commercial = {
        // 总数量
        totalQuantity: 0,
        // 总面积
        grossArea: 0,
      };
    },
  },
};
</script>

<style scoped>
.yunnan-content {
  width: 100%;
  margin: auto;
  background: #ffffff;
}
.central-yunnan-main {
  margin: 0 auto;
}
.central-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 60%;
  margin: 0 auto 20px auto;
}
.central-yunnan-main-item {
  flex: 1;
  margin-top: 20px;
  color: #ffffff;
  height: 54px;
  line-height: 54px;
}
.central-yunnan-card1 {
  background: #00b7ee;
  height: 100%;
}
.central-yunnan-card2 {
  background: #f19149;
  height: 100%;
}
.card-title {
  margin-left: 20px;
}
.card-num {
  margin-left: 100px;
  font-size: 24px;
  font-weight: bold;
}
.card-unit {
  font-size: 14px;
  margin-left: 5px;
}
.card2-content {
  width: 60%;
  margin: 20px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
}
.card2-content-item {
  flex: 1;
  color: #ffffff;
  margin-left: 20px;
}
.card2-content-item:nth-child(1) {
  margin-left: 0;
}
.card2-content-name {
  text-align: center;
  background: #11a39f;
  height: 50px;
  line-height: 50px;
}
.card2-content-main-content {
  background: #13b5b1;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
}
.card2-content-main-title {
  font-size: 14px;
  margin-bottom: 5px;
}
.card2-content-num {
  font-size: 24px;
  font-weight: bold;
}
.card2-content-unit {
  margin-left: 5px;
  font-size: 14px;
}
.card2-content-name1 {
  background: #d35d6b;
}
.card2-content-name2 {
  background: #3d7cb5;
}
.card2-content-main-content1 {
  background: #eb6877;
}
.card2-content-main-content2 {
  background: #448aca;
}
</style>
